import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: 'クッキー（Cookie）ポリシー',
  },
});

export const meta: PageMeta = {
  title: strings.title,
};
